import React from "react"
import NetworkPage from "./NetworkPage"

import { ThemeProvider } from "./components/contexts/ThemeContext"

import 'semantic-ui-css/semantic.min.css'
import "./styles_network.scss"

const App = () => {
 
  return (
    <ThemeProvider>
      <div className="App">
       <NetworkPage/>
      </div>
    </ThemeProvider>
  )

}

export default App

